module.exports = __webpack_public_path__ + "static/media/car.7553f560.png";